module.exports = __webpack_public_path__ + "img/approval.4a2b3b76.svg";